// @ts-nocheck

import { createSelector } from 'reselect';

import { KLRoundIndexByRoundId } from '../../constants/order';
import { getRoundIdFromProps, selectKLUserRoundIndex } from '../user';

const selectIsLocked = createSelector(
  [getRoundIdFromProps, selectKLUserRoundIndex],
  (roundId, userRoundIndex) => KLRoundIndexByRoundId[roundId] > userRoundIndex,
);

const selectKLAnyRoundProps = createSelector([selectIsLocked], (isLocked) => ({
  isLocked,
}));

export default selectKLAnyRoundProps;
